import React from 'react';
import PropTypes from 'prop-types';
import { Radio, FormControlLabel, Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Ripples from 'react-ripples';
import rippledLabelRadioButtonStyles from './RippledLabelRadioButton.styles';
import reportSettingStyles from '../ReportSettings.style';

const StyledFormControlLabel = withStyles({
	label: {
		fontWeight: 500,
		fontSize: '0.875rem'
	}
})(FormControlLabel);

const RippledLabelRadioButton = ({
	btnSelected,
	width,
	value,
	label,
	specialClasses,
	isSmallScreen,
	disabled
}) => {
	const classes = rippledLabelRadioButtonStyles();
	const reportStyle = reportSettingStyles({ isSmallScreen });
	const getTooltipTxt = () => {
		if (disabled) {
			return 'Run continuously is disabled because the time range of your report is fixed.';
		}
		return '';
	};

	return (
		<Ripples>
			<Tooltip
				title={getTooltipTxt()}
				arrow
				classes={{ tooltip: classes.customTooltipStyle }}
				id={`tooltip-${value}`}>
				<StyledFormControlLabel
					style={{
						height: '20px',
						padding: '8px 0px 8px 0px',
						width: `${width / 2}px`
					}}
					disabled={disabled}
					variant="contained"
					aria-checked={btnSelected === value}
					role="radio"
					color="primary"
					tabIndex={0}
					id={`btn-${value}`}
					data-testid={`data-btn-${value}`}
					label={label}
					value={value}
					control={
						<Radio
							style={{ opacity: 0, width: '100%', position: 'absolute' }}
							tabIndex={0}
							aria-label={`run report ${value} radio button`}
						/>
					}
					aria-label={`run report ${value} radio button`}
					className={`${btnSelected === value ? classes.buttonActive : classes.buttonInactive} ${
						classes.buttonRadio
					} ${specialClasses === 'left' ? reportStyle.radioOnce : reportStyle.radioContinuous}`}
				/>
			</Tooltip>
		</Ripples>
	);
};

RippledLabelRadioButton.propTypes = {
	btnSelected: PropTypes.string,
	label: PropTypes.string,
	width: PropTypes.number,
	specialClasses: PropTypes.string,
	value: PropTypes.string.isRequired
};

export default RippledLabelRadioButton;
